import gql from 'graphql-tag'

export default gql`
  query NationalExperiencePages {
    cfNationalExperiencePageCollection {
      items {
        sys {
          id
        }
        title
        slug
      }
    }
  }
`
